import { render, staticRenderFns } from "./PaymentInput.vue?vue&type=template&id=72b10fe8"
import script from "./PaymentInput.vue?vue&type=script&lang=js"
export * from "./PaymentInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports